/**
 * QORUNAN VİDEO BU BRAUZERDƏ AÇILA BİLƏRMİ (2026-10-24, yalnız veb TV build-i).
 *
 * ⚠ NƏ ÖLÇÜLDÜ (prod `aud.error_logs`, 5 gün): LG NetCast TV brauzeri (Chrome/79) 7 dəfə,
 *   Android 14 TV WebView 1 dəfə `drm-load code=6001` — Shaka-nın «açar sistemi yoxdur»
 *   xətası (bu brauzerlərdə Widevine/PlayReady yoxdur). `isBrowserSupported()` yalnız
 *   EME API-nin VARLIĞINA baxır, ona görə yoxlamadan keçirdi.
 * ⚠ ƏVVƏL: xəta yalnız Shaka manifesti endirib açarı istəyəndə çıxırdı — o vaxta qədər
 *   baxış sessiyası artıq açılmışdı. Server limit dolanda ƏN KÖHNƏ sessiyanı bağlayır
 *   (`PlaybackSessionCommands` → `LimitReplaced`), yəni oynada bilməyən televizor
 *   ailənin telefondakı filmini kəsə bilərdi və heartbeat yeri tutmağa davam edirdi.
 * ⚠ NİYƏ BELƏ (mühafizəkar): `false` YALNIZ biletin HƏR açar sistemi açıq-aşkar
 *   `NotSupportedError` ilə rədd ediləndə qaytarılır. API yoxdursa, başqa xəta, taymaut
 *   və ya bir sistem belə qəbul edərsə — `true`, yəni köhnə yol (Shaka özü qərar verir).
 *   Konfiqurasiya qəsdən yumşaqdır (baseline avc1, cenc/sinf/skd): Shaka-nın öz sorğusu
 *   bundan sərtdir, bizim rəddimiz onunkundan əvvəl gəlir, amma onu qabaqlamır.
 */

const KEY_SYSTEMS: { [name: string]: string } = {
  widevine: 'com.widevine.alpha',
  playready: 'com.microsoft.playready',
  fairplay: 'com.apple.fps',
}

const PROBE_TIMEOUT_MS = 3000

type RequestAccess = (keySystem: string, configs: unknown[]) => Promise<unknown>

export function canPlayProtected(servers: { [name: string]: string } | null | undefined): Promise<boolean> {
  const nav = typeof navigator === 'undefined' ? null : (navigator as unknown as { requestMediaKeySystemAccess?: RequestAccess })
  const request = nav ? nav.requestMediaKeySystemAccess : undefined
  if (!servers) return Promise.resolve(true)
  // 2026-10-31: canlı Tizen 4.0-da 6001 ölçüldü. Mux CBCS şifrələyir;
  // Samsung CBCS-i 2019/Tizen 5-dən dəstəkləyir. Tək EME varlığı kifayət deyil.
  // Bu məhdudiyyət yalnız Mux axınına aiddir; başqa CENC provayderini bağlamırıq.
  const mux = Object.keys(servers).some((name) => /^https:\/\/license\.mux\.com\//i.test(servers[name] || ''))
  const tizen = typeof navigator === 'undefined' ? null : /Tizen[ /]([0-9]+(?:\.[0-9]+)?)/i.exec(navigator.userAgent)
  if (mux && tizen && Number(tizen[1]) < 5) return Promise.resolve(false)
  if (!nav || typeof request !== 'function') return Promise.resolve(true)

  const systems: string[] = []
  for (const name in servers) {
    if (Object.prototype.hasOwnProperty.call(servers, name) && servers[name] && KEY_SYSTEMS[name]) {
      systems.push(KEY_SYSTEMS[name] as string)
    }
  }
  if (systems.length === 0) return Promise.resolve(true)

  const configs = [{
    initDataTypes: ['cenc', 'sinf', 'skd'],
    videoCapabilities: [mux
      ? { contentType: 'video/mp4; codecs="avc1.42E01E"', encryptionScheme: 'cbcs' }
      : { contentType: 'video/mp4; codecs="avc1.42E01E"' }],
  }]

  return new Promise<boolean>((resolve) => {
    let pending = systems.length
    let done = false
    const finish = (value: boolean) => {
      if (done) return
      done = true
      resolve(value)
    }
    window.setTimeout(() => finish(true), PROBE_TIMEOUT_MS)
    for (let i = 0; i < systems.length; i++) {
      let attempt: Promise<unknown>
      try {
        attempt = request.call(nav, systems[i] as string, configs)
      } catch (error) {
        attempt = Promise.reject(error)
      }
      attempt.then(
        () => finish(true),
        (error: unknown) => {
          if (!error || (error as { name?: string }).name !== 'NotSupportedError') {
            finish(true)
            return
          }
          pending -= 1
          if (pending === 0) finish(false)
        },
      )
    }
  })
}

/**
 * Televizor brauzeri — host nginx-dəki `$kinobox_tv_browser` xəritəsi ilə EYNİ ifadə
 * (`nginx-host.conf`): əsas saytdan tv.kinobox.az-a məhz bu agentlər yönləndirilir.
 */
export function isTvUserAgent(agent: string): boolean {
  return /(smart[-_ ]?tv|tizen|web[o0]s|netcast|hbbtv|googletv|android[-_ ]?tv|android[^)]*(tv|mibox|shield|chromecast)|apple[-_ ]?tv|aft[bmsnt]|viera|bravia|ce-html|roku|vidaa)/i.test(agent)
}
